import { useDrawer } from '@/core/context/DrawerContext'
import { AppModule } from '@/core/modules/app/app.module'
import { Analytics } from '@core/services/mixpanel'
import { CustomTooltip } from '@atbay/component-lib'
import DigitalFootprintsIcon from '@assets/images/digital-footprint-icon.svg?react'
import { ButtonContainer } from './AddExternalAssetButton.styles'
import { AddExternalAssetButtonProps } from './AddExternalAssetButton.types'
import Typography from '@/ui/components/typography'

const DISABLED_TOOLTIP_TEXT = 'Available once the scan is complete'

const AddExternalAssetButton = ({
    label,
    drawerContentType,
    analyticsEvent,
    testId,
}: AddExternalAssetButtonProps) => {
    const { setDrawerState } = useDrawer()
    const { scanInProgress } = AppModule.useStore()
    const isDisabled = !!scanInProgress

    const openDrawer = () => {
        if (isDisabled) return
        Analytics.event(analyticsEvent)
        setDrawerState((prevState) => ({
            ...prevState,
            isDrawerOpen: true,
            drawerContentType,
        }))
    }

    return (
        <CustomTooltip
            title={DISABLED_TOOLTIP_TEXT}
            placement="top"
            alwaysShowOnHover={isDisabled}
        >
            <ButtonContainer
                onClick={openDrawer}
                data-testid={testId}
                isDisabled={isDisabled}
                aria-disabled={isDisabled}
            >
                <DigitalFootprintsIcon
                    className="icon"
                    width={28}
                    height={28}
                />
                <Typography variant="xs-bold">{label}</Typography>
            </ButtonContainer>
        </CustomTooltip>
    )
}

export default AddExternalAssetButton
